import { render, staticRenderFns } from "./LocationPlugin.vue?vue&type=template&id=a98c974c&scoped=true"
import script from "./LocationPlugin.vue?vue&type=script&lang=ts"
export * from "./LocationPlugin.vue?vue&type=script&lang=ts"
import style0 from "./LocationPlugin.vue?vue&type=style&index=0&id=a98c974c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98c974c",
  null
  
)

export default component.exports